import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const activityCategoryApi = createApi({
  reducerPath: 'activityCategoryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getActivityCategories: builder.query({
      query: () => '/api/admin/getAcitivityCatagory',
    }),
    getActivityById: builder.query({
      query: (id) => `/api/admin/getAcitivitybyId/${id}`,
    }),
    addEditActivityCategory: builder.mutation({
      query: (formData) => ({
        url: '/api/admin/addEditAcitivityCatagory',
        method: 'POST',
        body: formData,
      }),
    }),
    deleteActivityCategory: builder.mutation({
      query: (id) => ({
        url: `/api/admin/deleteAcitivityCatagory/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetActivityCategoriesQuery,
  useGetActivityByIdQuery,
  useAddEditActivityCategoryMutation,
  useDeleteActivityCategoryMutation,
} = activityCategoryApi;
